// extracted by mini-css-extract-plugin
export default {"pageWrapper":"offers2_pageWrapper__alz0h","verticalFiller":"offers2_verticalFiller__9KJNn","headerCell":"offers2_headerCell__SnI2v","actionsTrigger":"offers2_actionsTrigger__4ATWT"};